/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsFAQ = {
  init() {
    const $faqHeading = $('.faq-accordion > dt > button');

    $('.faq-accordion > dd').attr('aria-hidden', true);

    $faqHeading.attr('aria-expanded', false);

    $faqHeading.off('click activate').on('click activate', function () {
      const faqIcons = $(this).find('.icon');
      const state = $(this).attr('aria-expanded') === 'false';
      
      $(this).attr('aria-expanded', state);
      $(this).parent().next().slideToggle();
      $(this).parent().next().attr('aria-hidden', !state);
      
      // Handle icon rotation for caret style
      if (faqIcons.hasClass('icon--rotate')) {
        if (state) {
          // Opening - rotate caret up
          faqIcons.css('transform', 'rotate(180deg)');
        } else {
          // Closing - rotate caret down
          faqIcons.css('transform', 'rotate(0deg)');
        }
      } else if (faqIcons.length > 1) {
        // Fallback for plus/minus style if needed
        if (state) {
          faqIcons.eq(0).hide();
          faqIcons.eq(1).show();
        } else {
          faqIcons.eq(0).show();
          faqIcons.eq(1).hide();
        }
      }
      
      return false;
    });

    // Initialize accordions on page load
    $('.faq-accordion > dt > button').each(function() {
      const icons = $(this).find('.icon');
      const state = $(this).attr('aria-expanded') === 'true';
      
      if (icons.hasClass('icon--rotate')) {
        // Set initial rotation for carets
        icons.css('transform', state ? 'rotate(180deg)' : 'rotate(0deg)');
        icons.css('transition', 'transform 0.3s ease');
      } else if (icons.length > 1) {
        // Hide the second icon (minus) initially for plus/minus style
        icons.eq(1).hide();
      }
    });

    $faqHeading.on('keydown', function (event) {
      const keyCode = event.keyCode || event.which;
      if (keyCode === 13) {
        $(this).trigger('activate');
      }
    });
  },
  unload() {
    $('.faq-accordion > dt > button').off('click activate');
    $('.faq-accordion > dt > button').off('keydown');
  },
};

/******/ })()
;